import defaultState from './state';

const SAVE_CIKKCSOPORTS = (state, payload) => {
  state.cikkcsoports = payload;
};

export default {
  SAVE_CIKKCSOPORTS,
};
